<template>
  <div class="page-add">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="120px"
      class="form"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="转让人：" required>
            {{ruleForm.userName}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="角色名称：" prop="deptId">
            <el-select class="form-select" v-model="ruleForm.deptId" placeholder="请选择" @change="changeRole">
              <el-option v-for="item in roleList" :key="item.deptId" 
                :label="item.roleName" 
                :disabled="!item.isSelect"
                :value="item.deptId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="被转让用户：" prop="moveUserName">
            <el-input
              v-model="ruleForm.moveUserName"
              placeholder="姓名"
              @input="handleSendMessage"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="" prop="moveUserMobile">
            <el-input
              placeholder="手机号"
              v-model="ruleForm.moveUserMobile"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="10">
          <el-form-item>
            <a :href="EXCP"> <butn btntype="primary" title="下载模板"></butn> </a>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="10">
          <el-form-item
            class="scale"
            label="证明材料："
            prop="attachmentList"
          >
            <div class="m-b-12">
              <butn btntype="primary" title="下载模板" @click="downloadTemplate"></butn>
            </div>
            <upload
              :accepts="acceptsType"
              :limit="1"
              :path="'class/attachment'"
              v-model="ruleForm.attachmentList"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="消息通知：" prop="isSend" required>
            <el-radio-group v-model="ruleForm.isSend">
              <el-radio
                v-for="(item, i) in publicData"
                :key="i"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isSend">
        <el-col :span="14">
          <el-form-item label="消息内容：" prop="sendMessage">
            <el-input
              rows="3"
              type="textarea"
              v-model="ruleForm.sendMessage"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.isSend">
        <el-col :span="12">
          <el-form-item label="发送方式：" required>
            短信
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item style="text-align: center">
            <el-button @click="goBack">返回</el-button>
            <el-button @click="resetForm">重置</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { validMobile } from "@/utils/rules/validMobile.js";
import { getDataMap } from "@/api/sysParam";
import { savePermissionMove, userRoleList, getSmsTemplate } from "@/api/user";
import Upload from "@/components/upload/index";
import { permissionTransferTemplate } from "@/assets/excel/index.js";
import butn from "@/components/button/index";
import { downloadByUrl } from "../../../utils/common";

export default {
  components: { Upload, butn },
  data() {
    return {
      EXCP: permissionTransferTemplate,
      acceptsType: ['pdf', 'jpg','png'],
      publicData: [],
      ruleForm: {
        isSend: 1,
        attachmentList: [],
        moveUserName: "",
        moveUserMobile: "",
        sendMessage: "",
        roleId: "",
        userId: "",
        userName: "",
        deptId: "",
        deptRoleName: "",
      },
      roleList: [],
      sendMessageOrigin: "",
      rules: {
        attachmentList: [
          {
            required: true,
            message: "请上传文件",
            trigger: ["blur", "change"]
          }
        ],
        moveUserName: [
          { required: true, message: "请输入被转让用户姓名", trigger: ["blur", "change"] }
        ],
        moveUserMobile: [
          { required: true, validator: validMobile, trigger: ["blur", "change"] }
        ],
        deptId: [
          { required: true, message: "请选择角色名称", trigger: ["blur", "change"] }
        ],
        sendMessage: [
          { required: true, message: "获取消息内容失败", trigger: ["blur", "change"] }
        ],
        isSend: [
          {
            required: true,
            message: "请选择是否发送消息通知",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {
    getDataMap("IS_VALID").then((res) => {
      if (!res || res.code != 0) return;
      this.publicData = res.data;
    });
    this.ruleForm.userId = this.$route.query.id;
    this.ruleForm.userName = this.$route.query.userName;
    this.initPage();
  },
  methods: {
    resetForm() {
      this.ruleForm = {
        isSend: 1,
        attachmentList: [],
        moveUserName: "",
        moveUserMobile: "",
        roleId: "",
        userId: this.ruleForm.userId,
        userName: this.ruleForm.userName,
        sendMessage: this.ruleForm.sendMessage,
        deptId: "",
        deptRoleName: "",
      }
      this.handleSendMessage();
    },
    changeRole(val) {
      let item = this.roleList.filter(
        (ele) => ele.deptId == val
      );
      this.ruleForm.roleId = item[0].roleId;
      this.ruleForm.deptRoleName = item[0].roleName;
      this.handleSendMessage();
    },
    // 替换消息模版通配符
    handleSendMessage() {
      let sendMessage = this.sendMessageOrigin;
      if (this.ruleForm.deptRoleName.length > 0) {
        sendMessage = sendMessage.replace(
          "{管理组织-角色名称}",
          `${this.ruleForm.deptRoleName}`
        );
      }
      if (this.ruleForm.moveUserName.length > 0) {
        sendMessage = sendMessage.replace(
          "{被转让人姓名}",
          `${this.ruleForm.moveUserName}`
        );
      }
      this.ruleForm.sendMessage = sendMessage;
    },
    goBack() {
      this.$router.push('/liaison');
    },
    getSmsTemplate() {
      // 短信模板类型（1 同意申请人模板 2 同意被转让人模板 3 不同意申请人模板 4 权限转让申请模板）
      getSmsTemplate({ smsTypes: 4 }).then((res) => {
        if (!res || res.code != 0) return;
        let { data } = res;
        this.sendMessageOrigin = data[0];
        this.sendMessageOrigin = this.sendMessageOrigin.replace(
          "{转让人姓名}",
          `${this.ruleForm.userName}`
        );
        this.ruleForm.sendMessage = this.sendMessageOrigin;
      });
    },
    getRoleList() {
      userRoleList({ userId: this.ruleForm.userId }).then((res) => {
        if (!res || res.code != 0) return;
        let { data } = res;
        this.roleList = data;
      });
    },
    initPage() {
      this.getRoleList();
      this.getSmsTemplate();
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = {
                ...this.ruleForm,
              };
              params["attachment"] = JSON.stringify(this.ruleForm.attachmentList);
              // params["verifyUrl"] = this.ruleForm.attachmentList[0].url;
              savePermissionMove(params).then((res) => {
                if (!res || res.code != 0) return;
                this.goBack();
                this.$refs["ruleForm"].resetFields();
              });
            })
            .catch((_) => _);
        }
      });
    },
    downloadTemplate() {
      downloadByUrl(null, this.EXCP);
    }
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.m-b-12 {
  margin-bottom: 12px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

#video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
.form-select {
  width: 100%;
}
</style>
